<template>
    <v-container id="inscmesas-ivt">
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="alineacentro DatosMatriculado">
            <v-card-title class="DatosMatriculado">
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card
                    dark
                    color="success"
                    class="alineacentro DatosMatriculado"
                  >
                    <strong>INSCRIPCIÓN A MESAS DE EXÁMENES FINALES</strong>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col>
                  <v-spacer />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-select
                    v-model="filtros.idcarrera"
                    :items="listacarreras"
                    label="Carrera"
                    item-text="carrera"
                    item-value="idcarrera"
                    height="20px"
                    no-data-text="Sin Carreras"
                    v-on:change="Listar"
                  />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-select
                    v-model="filtros.anio"
                    :items="listaanios"
                    label="Año"
                    item-text="anio"
                    item-value="anio"
                    height="20px"
                    v-on:change="Listar"
                    class="ocupa30"
                  />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-select
                    v-model="filtros.idturno"
                    :items="listaturnos"
                    label="Turno"
                    item-text="nombrecompleto"
                    item-value="idturno"
                    height="20px"
                    v-on:change="Listar"
                    class="ocupa30"
                    no-data-text="Sin Turnos Disponibles"
                  />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-btn
                    class="ma-2"
                    x-small
                    color="blue"
                    title="Listar Inscripciones a Exámenes Finales"
                    @click="listar"
                    :disabled="!permisolectura || listaturnos.length===0 || listacarreras.filter(c=> c.idcarrera===filtros.idcarrera)[0].idnivel!=4 || (filtros.idturno===0 || filtros.idturno===null)"
                  >
                    <v-icon dark> mdi-magnify</v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2"
                    x-small
                    color="blue"
                    title="Nueva Inscripción"
                    @click="nueva"
                    :disabled="!permisoescritura || listaturnos.length===0 || listacarreras.filter(c=> c.idcarrera===filtros.idcarrera)[0].idnivel!=4 || (filtros.idturno===0 || filtros.idturno===null)"
                  >
                    <v-icon dark> mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12">
                  <v-data-table
                    :headers="columnas"
                    :items="lista"
                    :items-per-page="lista.length"
                    hide-default-footer
                    item-key="idmesaexamen"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Registros"
                  >
                    <template v-slot:item.actions="{ item }">
                      <v-tooltip v-if="item.permiteborrar" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            small
                            icon
                            color="green"
                            @click="borrarinscripcion(item)"
                            v-bind="attrs"
                            v-on="on"
                            :disabled="!permisoescritura"
                          >
                            <v-icon>mdi-delete-circle</v-icon>
                          </v-btn>
                        </template>
                        <span>Borrar Inscripción</span>
                      </v-tooltip>
                      <v-chip v-else color="red" dark>
                        <p class="textofilagrilla">{{ item.observaborrar }}</p>
                      </v-chip>
                      <v-tooltip v-if="1===2" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span>&nbsp;</span>
                          <v-btn
                            small
                            icon
                            color="green"
                            @click="imprimircomprobante(item)"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon>mdi-check</v-icon>
                          </v-btn>
                        </template>
                        <span>Imprimir Comprobante</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogmensaje" persistent max-width="350">
        <v-card>
          <v-card-title class="headline">
            {{ mensajetitulo }}
          </v-card-title>
          <v-card-text>
            {{ mensajecuerpo }}
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
                color="green darken-1"
                text
                @click="dialogmensaje = false;if (mensajehome === true) {$router.push('Home');}"
            >
                Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loading" full-width>
        <v-container
            fluid
            class="full-height"
            style="background-color: rgba(255, 255, 255, 0.5)"
        >
          <v-row
            align="center"
            justify="center"
            style="height: 100vh"
            no-gutters
            dense
          >
            <v-col class="elementocentrado">
              <v-progress-circular indeterminate color="primary" />
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>
      <v-dialog v-model="dialoginscripcion" persistent full-width>
        <v-card>
          <v-card-title class="headline">
            {{ dialoginscripciontitulo }}
          </v-card-title>
          <v-card-actions>
            <v-row>
              <v-col cols="12" class="alineaderecha">
                <v-btn color="red darken-1" text @click="dialoginscripcion = false">
                  Cerrar
                </v-btn>
              </v-col>
            </v-row>
            <br />
            <br />
          </v-card-actions>
          <v-card-text>
            <br />
            <br />
            <v-row class="text-center">
              <v-col cols="12" md="3" lg="3">
                <v-select
                  v-model="edited.llamado"
                  :items="listallamados"
                  label="LLamado"
                  item-text="llamado"
                  item-value="nro"
                  height="20px"
                  v-on:change="listarmesasparainscribir"
                  class="ocupa30"
                />
              </v-col>
              <v-col cols="12" md="9" lg="9" class="alineaizquierda">
                <v-btn
                  class="ma-2"
                  x-small
                  color="blue"
                  title="Listar Mesas de Exámenes"
                  @click="listarmesasparainscribir"
                >
                  <v-icon dark> mdi-magnify</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col cols="12">
                <v-data-table
                  :headers="columnasmesasparainscribir"
                  :items="listamesasparainscribir"
                  :items-per-page="listamesasparainscribir.length"
                  hide-default-footer
                  item-key="idmesaexamen"
                  class="elevation-1"
                  dense
                  no-data-text="Sin Registros"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-tooltip v-if="item.permiteseleccionar" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          icon
                          color="green"
                          @click="seleccionarmesa(item)"
                          v-bind="attrs"
                          v-on="on"
                          :disabled="!item.permiteseleccionar"
                        >
                          <v-icon>mdi-arrow-right-box</v-icon>
                        </v-btn>
                      </template>
                      <span>Seleccionar</span>
                    </v-tooltip>
                    <v-chip v-else color="red" dark>
                      <p class="textofilagrilla">{{ item.observaseleccionar }}</p>
                    </v-chip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <ConfirmDlg ref="confirm" />
    </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
export default {
  name: "inscmesas",
  components: {
    ConfirmDlg: ConfirmDlg
  },
  data() {
    return {
      loading: false,
      usuario: '',
      permisolectura: false,
      permisoescritura: false,
      idrol: 0,
      roles: [],
      nromodulo: 22,
      dialogmensaje: false,
      mensajetitulo: '',
      mensajecuerpo: '',
      mensajehome: false,
      columnas: [
        {
          text: "Op.",
          value: "actions",
          width: 55
        },
        {
          text: "ID Mesa",
          align: "center",
          sortable: true,
          value: "idmesaexamen",
          width: 80
        },
        {
          text: "Llamado",
          align: "center",
          sortable: true,
          value: "llamado",
          width: 80
        },
        {
          text: "Fecha",
          align: "center",
          sortable: true,
          value: "fechahoradmy",
          width: 110
        },
        {
          text: "Asignatura",
          align: "center",
          sortable: true,
          value: "asignatura",
          width: 200
        },
        {
          text: "Presidente",
          align: "center",
          sortable: true,
          value: "presidente",
          width: 150
        },
        {
          text: "Vencimiento",
          align: "center",
          sortable: true,
          value: "vencimientoinscripcionhastadmy",
          width: 110
        }
      ],
      lista: [],
      filtros: {
        idalumno: 0,
        idcarrera: 0,
        anio: 0,
        idturno: 0
      },
      listacarreras: [],
      listaanios: [],
      listaturnos: [],
      dialoginscripcion: false,
      dialoginscripciontitulo: '',
      listallamados: [{nro: 0, llamado: 'TODOS'}, {nro: 1, llamado: '1'},{nro: 2, llamado: '2'}],
      edited: {
        llamado: 0,
        idmesaexamen: 0,
        idalumno: 0,
        usuario: 0
      },
      columnasmesasparainscribir: [
        {
          text: "Op.",
          value: "actions",
          width: 55
        },
        {
          text: "ID Mesa",
          align: "center",
          sortable: true,
          value: "idmesaexamen",
          width: 90
        },
        {
          text: "Llamado",
          align: "center",
          sortable: true,
          value: "llamado",
          width: 90
        },
        {
          text: "Fecha",
          align: "center",
          sortable: true,
          value: "fechahoradmy",
          width: 110
        },
        {
          text: "Asignatura",
          align: "center",
          sortable: true,
          value: "asignatura",
          width: 200
        },
        {
          text: "Presidente",
          align: "center",
          sortable: true,
          value: "presidente",
          width: 150
        },
        {
          text: "Venc Desde",
          align: "center",
          sortable: true,
          value: "vencimientodesdedmy",
          width: 100
        },
        {
          text: "Venc Hasta",
          align: "center",
          sortable: true,
          value: "vencimientohastadmy",
          width: 100
        }
      ],
      listamesasparainscribir: []
    };
  },
  mounted() {
    this.loading = true;
    this.roles=[];
    this.usuario = localStorage.getItem("user");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    var rolesuser = localStorage.getItem("rolesuserid").split(',');
    rolesuser.forEach((elemento) => {
        this.roles.push(parseInt(elemento));
    });
    var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 1);
    if (existeper.length === 0) {
      this.loading = false;
      this.MostrarMensaje("Error","No tiene permisos para acceder a este módulo.",true);
    } else {
      this.permisolectura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 2).length > 0 ? true : false;
      this.permisoescritura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 3).length > 0 ? true : false;
      if(this.roles.includes(1)) {
        this.filtros.idalumno= parseInt(localStorage.getItem("idpersona"));
      }else{
        this.filtros.idalumno= 0;
      }
      var i=0;
      var anioactual= (new Date()).getFullYear();
      for(i=2024;i<=anioactual;i++) {
        this.listaanios.push({anio: i});
      }
      this.filtros.anio= (new Date()).getFullYear();
      axios.get('alumno/carrerasalumno/0/' + this.usuario + '/0/0').then((result) => {
        if(result.data.resultado===0){
          this.listacarreras = result.data.datos;
          this.filtros.idcarrera= this.listacarreras.length>0 ? this.listacarreras[0].idcarrera : 0;
          axios.get('examenfinal/ListaTurnos/' + this.usuario + '/' + this.filtros.anio.toString() + '/0/' + this.filtros.idcarrera).then((result) => {
            if(result.data.resultado===0)
            {
              var datos = result.data.datos;
              var idsedecarrera= this.listacarreras.filter(c=> c.idcarrera===this.filtros.idcarrera)[0].idsede;
              var lista= datos.slice();
              this.listaturnos= lista.filter(t=> t.idsede===idsedecarrera);
              this.filtros.idturno= lista.length>0 ? lista[0].idturno : 0;
              if(this.filtros.idturno>0){
                this.listar();
              }else{
                this.loading=false;
              }
            }else{
              this.loading = false;
              this.mostrarmensaje('Error', result.data.resultadomensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.mostrarmensaje('Error', error, false);
          })
        }else{
          this.loading = false;
          this.MostrarMensaje('Error', result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje('Error', error, false);
      });
    }
  },
  methods: {
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    listar () {
      this.loading = true;
      var parametros= JSON.stringify({idalumno: this.filtros.idalumno, idcarrera: this.filtros.idcarrera, anio: this.filtros.anio, idturno: this.filtros.idturno, usuario: this.usuario});
      axios.post('examenfinal/PostListaInscripcionesMesasExamenesxAlumno',parametros, { headers: { "Content-Type": "application/json",}}).then((result) => {
        if(result.data.resultado===0){
          this.lista = result.data.datos;
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
      });
    },
    nueva () {
      this.loading= true;
      this.edited= {
        llamado: 0,
        idmesaexamen: 0,
        idalumno: this.filtros.idalumno,
        usuario: this.usuario
      };
      this.dialoginscripciontitulo='Nueva Inscripción';
      this.dialoginscripcion= true;
      this.listarmesasparainscribir();
    },
    listarmesasparainscribir () {
      this.loading = true;
      var parametros= JSON.stringify({idcarrera: this.filtros.idcarrera, anio: this.filtros.anio, idturno: this.filtros.idturno,llamado: this.edited.llamado,idalumno: this.filtros.idalumno, usuario: this.usuario});
      axios.post('examenfinal/PostListaMesasExamenesxTurno',parametros, { headers: { "Content-Type": "application/json",}}).then((result) => {
        if(result.data.resultado===0){
          this.listamesasparainscribir = result.data.datos;
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
      });
    },
    seleccionarmesa (item) {
      this.loading=true;
      this.edited.idmesaexamen=item.idmesaexamen;
      var inscripcion= JSON.stringify(this.edited);
      axios.post("examenfinal/PostInscripcionMesa",inscripcion, { headers: { "Content-Type": "application/json",}}).then((result) => {
        if(result.data.resultado===0){
          this.dialoginscripcion=false;
          this.listar();
        }else{
          this.loading = false;
          this.MostrarMensaje('Error', result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje('Error', error, false);
      });
    },
    async borrarinscripcion (item) {
      if (await this.$refs.confirm.open('Confirmar','Esta seguro de querer borrar la inscripción al examen?')) {
        this.loading=true;
        const examen = JSON.stringify({idmesaexamen: item.idmesaexamen,idalumno: this.filtros.idalumno, usuario: this.usuario});
        axios.post("examenfinal/PostBorrarInscripcionexamenfinal", examen, { headers: {"Content-Type": "application/json", }}).then((result) => {
          if (result.data.resultado === 0) {
            this.listar();
          }else{
            this.loading = false;
            this.MostrarMensaje("Error", result.data.resultadomensaje, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
      }
    },
    imprimircomprobante () {
     /* this.loading = true;
      axios.post("reportes/GetReporte", {idreporte: 10, formato: 'PDF', nromodulo: parseInt(this.nromodulo), usuario: this.usuario.toString(), listaparametros: [{ orden: 1, nombre: "idmesa", valor: item.idmesaexamen.toString()} ] },{ headers: { "Content-Type": "application/json" }}).then((result) => {
        this.loading = false;
        if (result.data.toString().startsWith("Error") === false) {
          if(item.idestado<5){
            this.loading = false;
            window.open(result.data, "_blank");
          }else{
            this.preguntamarcaimpresion(result.data, item.idmesaexamen);
          }
        } else {
          this.mostrarmensaje("Error", result.data, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.mostrarmensaje("Error", error, false);
      }); */
    }
},
  computed: {
    fechalocalfecha: function () {
      if (this.edited.fecha != null && this.edited.fecha != "") {
        var fecha = new Date(this.edited.fecha);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    },
  },
};
</script>
<style>
.style-1 {
  background-color: rgb(215,215,44)
}
.style-2 {
  background-color: rgb(114,114,67)
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.680rem !important;
    height: 25px !important;
}

.titulodialog {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
}

.textofilagrilla {
  font-size: 0.680rem !important;
  height: 5px !important;
}

.v-application--is-ltr .v-banner--is-mobile .v-banner__wrapper {
    padding-left: 1px !important;
}

.v-banner--is-mobile .v-banner__wrapper {
    flex-wrap: wrap;
    padding-top: 1px !important;
}

.v-application--is-ltr .v-banner__wrapper {
    padding: 1px 1px 1px 1px !important;
}

.letraroja {
  color: red;
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
</style>
